<template>
  <div>
    <ed-modal
      :title="
        'DETALHAMENTO DA CONSULTA EXTERNA ' +
        (this.formData.consulta
          ? ' - ' + this.formData.consulta.funcionario.nome
          : '')
      "
      :modal="showConsultaDetail"
      :loading="loadingConsultaDetail"
      width="70%"
    >
      <div slot="modal-content">
        <ConsultaDetalhe :consulta="formData.consulta" />
      </div>
    </ed-modal>

    <ed-modal
      :title="
        'ALTERAR PCMSO DA CONSULTA EXTERNA ' +
        (this.formData.consulta
          ? ' - ' + this.formData.consulta.funcionario.nome
          : '')
      "
      :modal="showAlterarRevisao"
      :onSave="onAlterarPcmso"
      :disabledSave="checkAlterarPcmso"
      width="70%"
    >
      <div slot="modal-content">
        <ConsultaAlterarRevisao
          :consulta="formData.consulta"
          :consultaNova="formData.consultaNova"
          :ultimaRevisao="formData.ultima_revisao"
        />
      </div>
    </ed-modal>

    <TableView
      :onSearch="getConsulta"
      :tableHead="tableHead"
      :tableData="tableData"
      :loadingTable="loadingTable"
      :pagination="pagination"
      :onFilter="getConsulta"
      :filterBadge="filterBadge"
      :response="response"
    >
      <div slot="table-filter-content">
        <ed-form
          :data="formFilter"
          :config="config"
          :response="response"
          :itens="filterItems"
          :onClear="onClear"
        />
      </div>
    </TableView>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import EdForm from "common/form";
import EdModal from "common/modal";
import EdAlert from "common/alert";
import FilterItems from "./_form/consulta-externa-filtro";
import ConsultaDetalhe from "./_include/consulta-detalhe";
import ConsultaAlterarRevisao from "./_include/consulta-alterar-revisao";

export default {
  name: "empresa",
  components: {
    TableView,
    ConsultaDetalhe,
    ConsultaAlterarRevisao,
    EdForm,
    EdModal,
    EdAlert,
  },
  mixins: [Rest],
  watch: {
    "formFilter.id_empresa"() {
      this.getFuncionario();
      this.getFDT();

      this.config.disabled.id_funcionario = this.formFilter.id_empresa
        ? false
        : true;
      this.config.disabled.id_fdt = this.formFilter.id_empresa ? false : true;

      this.formFilter.id_funcionario = null;
      this.formFilter.id_fdt = null;
    },
  },
  data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_cre: this.getCredenciada,
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_funcao: this.getFuncao,
          id_fdt: this.getFDT,
        },
        list: {
          id_cre: [],
          id_empresa: [],
          id_funcionario: [],
          id_funcao: [],
          id_fdt: [],
        },
        loading: {
          id_cre: false,
          id_empresa: false,
          id_funcionario: false,
          id_funcao: false,
          id_fdt: false,
        },
        disabled: {
          id_funcionario: true,
          id_fdt: true,
        },
      },
      formData: {
        consulta: null,
        consultaNova: null,
        ultima_revisao: null,
      },
      formFilter: {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0,
      },
      pagination: {},
      response: {},
      filterItems: [],
      tableHead: [
        {
          key: "consulta",
          sortable: true,
          show_tipo_aso: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "credenciada",
          sortable: true,
          label: "Credenciada",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "status",
          sortable: true,
          show_status: true,
          label: "Status",
        },
        {
          key: "data_agendamento",
          sortable: true,
          label: "Agendamento",
        },
        {
          key: "data_cadastro",
          sortable: true,
          label: "Cadastro",
        },
      ],
      tableData: [],
      loadingTable: true,
      loadingEditAll: false,
      loadingConsultaDetail: false,
      showFormFilter: false,
      showConsultaDetail: false,
      showAlterarRevisao: false,
      filterBadge: 0,
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getConsulta();
    this.getEmpresa();
    this.getCredenciada();
    this.getFuncao();

    this.filterItems = FilterItems;
  },

  computed: {
    checkAlterarPcmso() {
      return this.formData.consultaNova &&
        this.formData.consultaNova.id_fdt &&
        this.formData.consultaNova.id_ghe &&
        this.formData.consultaNova.id_tabela_preco &&
        this.formData.consultaNova.id_funcao
        ? false
        : true;
    },
  },
  methods: {
    onClear() {
      this.formFilter = {
        id_cre: 1,
        id_funcao: null,
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_status: [],
        id_tipo_aso: [],
        created_at: [],
        agendamento_at: [],
        deleted: 0,
      };
    },

    onEdit(data) {
      this.loadingTable = true;

      this.get("empresa/consulta/externa/" + data.id + "/gerar").then(
        (result) => {
          result = result[0];

          if (result.status == 200) {
            window.open(
              process.env.URL_CS +
                "/app/consulta.php?con=" +
                result.data.id_con +
                "&force=1",
              "_top"
            );
          } else {
            this.getConsulta();

            this.$alert(result.msg, "Atenção", {
              confirmButtonText: "OK",
            });
          }
        }
      );
    },

    onShowConsulta(data) {
      this.showConsultaDetail = !this.showConsultaDetail;
      this.loadingConsultaDetail = true;
      this.formData.consulta = null;

      this.get("empresa/consulta/externa/" + data.id).then((result) => {
        result = result[0];

        this.loadingConsultaDetail = false;

        if (result.status == 200) {
          this.formData.consulta = result.data;
        }
      });
    },

    onGerarConsulta(data) {
      var label = data.funcionario.nome,
        self = this;

      this.$confirm(
        "O sistema vai gerar uma consulta definitiva para o funcionário " +
          label +
          ". Deseja continuar?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self
          .get(
            "pcmso/revisao/" +
              data.empresa.id +
              "/" +
              data.fdt.id +
              "/ultima-revisao"
          )
          .then((result) => {
            result = result[0];

            self.formData.ultima_revisao = result.data;
            self.formData.consulta = data;
            self.formData.consultaNova = {
              id: 0,
              id_fdt: data.fdt.id,
              id_emp: data.empresa.id,
              id_ghe: null,
              id_funcao: null,
              id_tabela_preco: null,
              id_mf_fdt: null,
              id_mf_ghe: null,
              id_mf_funcao: null,
              data_age: this.toDate(null, true),
              id_tipo_aso: data.tipo_aso.id,
              periodicidade: data.periodicidade,
              id_funcionario: data.funcionario.id,
              id_con_ext_original: data.id,
            };

            let diff = this.$utilidade.diffDays(
              data.data_age,
              this.$utilidade.toDate(null, true, "YYYY-MM-DD"),
              "d"
            );

            console.log("validar revisao", [data, result.data]);

            if (
              diff <= 0 &&
              (!result.data ||
                !data.revisao ||
                data.revisao.id != result.data.id)
            ) {
              self.showAlterarRevisao = !self.showAlterarRevisao;
            } else {
              self.loadingTable = true;

              self
                .get("empresa/consulta/externa/" + data.id + "/gerar")
                .then((result) => {
                  result = result[0];

                  if (result.status == 200) {
                    window.open(
                      this.env.url_cs +
                        "/app/consulta.php?con=" +
                        result.data.id_con,
                      "_top"
                    );
                  } else {
                    self.getConsulta();

                    this.$alert(result.msg, "Atenção", {
                      confirmButtonText: "OK",
                    });
                  }
                });
            }
          });
      });
    },

    onAlterarPcmso() {
      self = this;

      this.$confirm(
        "O sistema vai alterar o PCMSO e exames vinculados nessa consulta e o processo não poderá ser revertido. Deseja continuar?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        self.$root.$loading.set(true);

        if (this.formData.consulta.tipo_aso.id == 50) {
          this.formData.consultaNova.id_mf_fdt =
            this.formData.consultaNova.id_fdt;
          this.formData.consultaNova.id_mf_ghe =
            this.formData.consultaNova.id_ghe;
          this.formData.consultaNova.id_mf_funcao =
            this.formData.consultaNova.id_funcao;
        }

        let filter = {
          id_fdt: this.formData.consultaNova.id_fdt,
          id_funcao: this.formData.consultaNova.id_funcao,
          id_ghe: this.formData.consultaNova.id_ghe,
          periodicidade: this.formData.consulta.periodicidade,
          id_funcionario: this.formData.consulta.funcionario.id,
          hoje: this.$utilidade.toDate(null, true),
          id_tipo_aso: [this.formData.consulta.tipo_aso.id],
          pcd: 0,
          show_tabela_preco: 1,
        };

        self
          .post(
            "empresa/consulta/externa/" +
              this.formData.consulta.id +
              "/alterar",
            this.formData.consultaNova,
            filter
          )
          .then((result) => {
            result = result[0];

            console.log("altear consulta result", result);
            self.$root.$loading.set(false);

            if (result.status == 200) {
              window.open(
                this.env.url_cs + "/app/consulta.php?con=" + result.data.id_con,
                "_top"
              );
            }
          });
      });
    },

    getFuncao(_search) {
      this.config.loading.id_funcao = true;
      this.config.list.id_funcao = [];

      this.get("/funcao", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_funcao = false;

        if (result.status == 200) {
          this.config.list.id_funcao = result.data.data;
        }
      });
    },

    getCredenciada(_search) {
      this.config.loading.id_cre = true;
      this.config.list.id_cre = [];

      this.get("/credenciada", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_cre = false;

        if (result.status == 200) {
          this.config.list.id_cre = result.data.data;
        }
      });
    },

    getEmpresa(_search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_empresa = false;

        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario(_search) {
      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcionario = true;

        if (result.status == 200) {
          this.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getFDT() {
      if (!this.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, {
        pagination: 100,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
        }
      });
    },

    getConsulta(_search, _page, _pagination, _loading) {
      this.loadingTable = true;
      this.response = {};

      if (this.formFilter.agendamento_at.length != 2) {
        var hoje = this.toDate(null, true),
          ontem = this.toDate(this.addDate(-10, null, "D"), true),
          amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formFilter.agendamento_at = [ontem, amanha];
      }

      this.filterBadge =
        (this.formFilter.id_funcao ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0) +
        (this.formFilter.id_cre ? 1 : 0) +
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.id_fdt ? 1 : 0) +
        (this.formFilter.created_at.length > 0 ? 1 : 0) +
        (this.formFilter.agendamento_at.length > 0 ? 1 : 0) +
        this.formFilter.id_tipo_aso.length +
        this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta/externa", {
        search: _search,
        page: _page,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.loadingTable = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var style = "",
              color = "#6fc956",
              title = "Agendamento",
              hoje = this.toDate(null, true),
              data_age = this.toDate(data[i].data_age, true),
              diff = this.diffDays(data_age, hoje);

            if (data[i].id_con) {
              color = "#6fc956";
            } else if (diff > 0) {
              color = "#e07d59";
            } else if (diff == 0) {
              color = "#6fc956";
            } else {
              color = "#7797ef";
            }

            var item = {
              consulta: data[i].id_con ? data[i].id_con : "---",
              credenciada: data[i].credenciada
                ? data[i].credenciada.nome
                : null,
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario
                ? data[i].funcionario.nome
                : null,
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              tipo_consulta: data[i].tipo_aso
                ? data[i].tipo_aso.descricao
                : null,
              status: data[i].tipo_status
                ? data[i].tipo_status.descricao
                : null,
              data_cadastro: this.toDate(data[i].created_at, false),
              data_agendamento: data[i].data_age
                ? this.toDate(data[i].data_age, true)
                : null,
              style: data[i].deleted_at ? 'color:red;"' : "color:" + color,
              _data: data[i],
              options: {
                disable_delete: !this.validarPermissao(560),
                disable_edit: !this.validarPermissao(559),
              },
              buttons: [],
            };

            if (
              this.validarPermissao(559) &&
              data[i].credenciada.padrao == 1 &&
              data[i].tipo_status.id != 194 &&
              data[i].tipo_status.id != 195
            ) {
              if (!data[i].id_con) {
                item.buttons.push({
                  icon: "fa fa-paper-plane",
                  color: "success",
                  title:
                    "Gerar Consulta (Ação necessária para prosseguir com o atendimento)",
                  click: this.onGerarConsulta,
                });
              } else {
                item.buttons.push({
                  icon: "fa fa-pencil-square-o",
                  color: "primary",
                  title:
                    "Consulta já foi gerada. Clique aqui para abrir a consulta",
                  click: this.onEdit,
                });
              }
            }

            item.buttons.push({
              icon: "fa fa-info-circle",
              color: "warning",
              title: "Detalhes da consulta",
              click: this.onShowConsulta,
            });

            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// index.vue?704620ed